import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Mail, Save, Send, Loader2 } from "lucide-react";

export const ReportEmails = () => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/accounts/report-emails").then((r) => setText(r.data.emails.join(", "))).catch(() => {}); }, []);
  const save = async () => {
    setBusy("save");
    try {
      const r = await api.put("/accounts/report-emails", { emails: text.split(/[,;\s]+/).filter(Boolean) });
      setText(r.data.emails.join(", ")); toast.success("Email list saved");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); } finally { setBusy(""); }
  };
  const sendNow = async () => {
    setBusy("send");
    try { const r = await api.post("/accounts/send-report-now"); toast.success(`Summary sent to ${r.data.to.join(", ")}`); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); } finally { setBusy(""); }
  };
  return (
    <Card className="bg-card/40 border-gold/20 p-4 mb-6" data-testid="report-emails">
      <p className="eyebrow text-gold flex items-center gap-1.5 mb-1"><Mail className="w-4 h-4" /> Nightly accounts email · 11:30 PM IST</p>
      <p className="text-xs text-muted-foreground mb-3">Today's money in, money out and net, plus month-to-date, goes to these addresses every night. Separate with commas.</p>
      <div className="flex flex-wrap gap-2">
        <Input value={text} onChange={(e) => setText(e.target.value)} className="flex-1 min-w-[240px] h-9 bg-card/60" placeholder="company@example.com, accountant@example.com" data-testid="report-emails-input" />
        <Button size="sm" onClick={save} disabled={!!busy} data-testid="report-emails-save" className="h-9 bg-gold text-[#0a2e22] hover:bg-gold/90 gap-1.5">{busy === "save" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Save</Button>
        <Button size="sm" variant="outline" onClick={sendNow} disabled={!!busy} data-testid="report-emails-send-now" className="h-9 border-gold/40 text-gold gap-1.5">{busy === "send" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Send today's summary now</Button>
      </div>
    </Card>
  );
};
